import { render } from "./TutupKaunter.vue?vue&type=template&id=0aede06e"
import script from "./TutupKaunter.vue?vue&type=script&lang=js"
export * from "./TutupKaunter.vue?vue&type=script&lang=js"

import "./TutupKaunter.vue?vue&type=style&index=0&id=0aede06e&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__